import { render, staticRenderFns } from "./BTN007n_switching.vue?vue&type=template&id=da594414&"
import script from "./BTN007n_switching.vue?vue&type=script&lang=js&"
export * from "./BTN007n_switching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports